import src from "IMAGE";
export default { src, width: 1306, height: 1127, blurWidth: 0, blurHeight: 0};
